/**
 * Authentication utilities
 */

const SESSION_KEY = 'annea_portal_session';

export const auth = {
  setAuthenticated(): void {
    localStorage.setItem(SESSION_KEY, 'true');
  },

  clear(): void {
    localStorage.removeItem(SESSION_KEY);
  },

  isAuthenticated(): boolean {
    return localStorage.getItem(SESSION_KEY) === 'true';
  },
};
